export default {
  login: () => import("/app/layouts/login.vue"),
  management: () => import("/app/layouts/management.vue")
}